<section id="services" class="services section-bg">
  <div class="container">

    <header class="section-header">
      <h2>LIFE @TGS </h2>
      <p>One of the Growing &amp; Future Ready School affiliated to CBSE New Delhi equipped with Ultra Modern Facilities </p>
    </header>

    <div class="row">


      <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon"  style="background: #154474;"><i class="fa-solid fa-graduation-cap text-white"></i></div>
          <h4 class="title"><a routerLink="/life/houses">Houses</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>
      <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon"  style="background: #154475;"><i class="fa-solid fa-fan text-white"></i></div>
          <h4 class="title"><a routerLink="/life/clubs">Clubs</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>

      <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-shuffle text-white"></i></div>
          <h4 class="title"><a routerLink="/life/workshop">Workshops &amp; Seminars</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>
      <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-chart-pie text-white"></i></div>
          <h4 class="title"><a routerLink="/life/social">Social Responsibility</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>

      <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-quote-left text-white"></i></div>
          <h4 class="title"><a routerLink="/life/expeditions">Expeditions</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>
  <div class="col-md-6 col-lg-2" >
        <div class="box">
          <div class="icon" style="background: #154475;"><i class="fa-solid fa-fan text-white"></i></div>
          <h4 class="title"><a routerLink="/life/camps">Camps</a></h4>
          <a href=""><i class="fa fa-hand-o-right" style="color: #154474" aria-hidden="true"></i></a><p></p>
        </div>
      </div>
      
  </div>

  </div>
</section>